'use strict';

const getCountryFromLocaleCookie = require('./modules/util/getCountryFromLocaleCookie'),
    appendParamsToUrl = require('./modules/util/appendParamsToUrl'),
    ajax = require('./modules/ajax'),
    shippingFormPrefix = 'dwfrm_singleshipping_shippingAddress_addressFields_',
    billingFormPrefix = 'dwfrm_billing_billingAddress_addressFields_',
    addressFormPrefix = 'dwfrm_profile_address_';

    const prefillAddress = {
    init: function () {
        //only add events for NL forms
        if (getCountryFromLocaleCookie() === 'NL') {
            $('body').on('blur', 'input[id$=' + shippingFormPrefix + 'postal], input[id$=' + shippingFormPrefix + 'houseNumber]', {formPrefix: shippingFormPrefix}, this.handleBlurEvent);
            $('body').on('blur', 'input[id$=' + billingFormPrefix + 'postal], input[id$=' + billingFormPrefix + 'houseNumber]', {formPrefix: billingFormPrefix}, this.handleBlurEvent);
            $('body').on('blur', 'input[id$=' + addressFormPrefix + 'postal], input[id$=' + addressFormPrefix + 'houseNumber]', {formPrefix: addressFormPrefix}, this.handleBlurEvent);
        }
    },

    /**
    * @function
    * @description Handles the blur event on postal code and housenumber fields
    * @param {Object} Event object, includes data
    */
    handleBlurEvent: function (event) {
        const $formFieldset = $(event.target).parents('fieldset');

        const postalCode = encodeURIComponent($.trim($formFieldset.find('#' + event.data.formPrefix + 'postal').val()));
        const houseNumber = encodeURIComponent($.trim($formFieldset.find('#' + event.data.formPrefix + 'houseNumber').val()));

        if (postalCode !== '' && houseNumber !== '') {
            prefillAddress.retrieveAddress(postalCode, houseNumber, event.data.formPrefix);
        }
    },

    /**
    * @function
    * @description Retrieves the address from the RGC service
    * @param {String} A dutch postal code
    * @param {String} A dutch house number
    * @param {String} The form prefix for the form that triggered the call
    */
    retrieveAddress: function (postalCode, houseNumber, formPrefix) {
        const url = appendParamsToUrl(Urls.rgcRetrieveAddress, {
            'postalCode': postalCode,
            'houseNumber': houseNumber,
            'format': 'ajax',
            'formPrefix': formPrefix
        });

        ajax.getJson({
            url: url,
            callback: this.setAddress
        });
    },

    /**
    * @function
    * @description Sets the retrieved Address data on the correct form, does nothing if request failed (error logged on server)
    * @param {Object} A JSON object response from the RGC service
    */
    setAddress: function (response) {
        if (response.success) {
            $('input[id$=' + response.formPrefix + 'street]').val(response.data.street).valid();
            $('input[id$=' + response.formPrefix + 'street]').trigger('change');
            $('input[id$=' + response.formPrefix + 'city]').val(response.data.city).valid();
            $('input[id$=' + response.formPrefix + 'city]').trigger('change');
        }
    }
};

module.exports = prefillAddress;
